import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { AuthenticationService } from '../services/authentication.service';
import { Configuration } from '../configurations/shared.config';
import { RoutingAuthenticationService } from '../services/routing-authentication';
import { InformationProvider } from './information.provider';
import { Title } from '@angular/platform-browser';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private titleService: Title, private auth: AuthenticationService, private routerAuth: RoutingAuthenticationService, private informationProvider: InformationProvider) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        // if the user is not logged in return
        if (!this.auth.validUser()) {
            // not logged in so redirect to login page
            this.auth.redirectUrl = state.url;
            this.router.navigate([Configuration.paths.loginUrl]);
            return Observable.of(false);
        }

        let url = state.url;
        let module = url.split('/').filter(x => x)[0];
        let title = `Altair - ${module[0].toUpperCase()}${module.substr(1)}`;
        this.titleService.setTitle(title);

        if (module) {
            this.informationProvider.changeCurrentModuleName(module);
        }

        return this.auth
            .validateToken()
            .flatMap(response => {
                const res = response.json();

                if (!res) {
                    this.router.navigate([Configuration.paths.loginUrl]);
                }
                else {
                    return this.routerAuth.validateUrl(url);
                }

                return Promise.resolve(res);
            })
            .map(isValid => {
                if (!isValid) {
                    //this.informationProvider.pageNotFound();
                   // this.router.navigate([Configuration.paths.unauthorizePage]);
                    this.router.navigate([Configuration.paths.loginUrl]);

                }

                return isValid;
            })
            .catch(error => {
                this.auth.removeUser();
                this.auth.redirectUrl = state.url;
                this.router.navigate([Configuration.paths.loginUrl]);
                return Observable.of(false);
            });
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/providers/auth-guard.component.ts